import React from 'react';
import { isRichContentEmpty } from '@wix/ricos';
import { emailRegex } from '../../common/utils/email-regex';
const getInitialFormState = (content, authorName, email) => ({
    authorName,
    email,
    content,
    isEmpty: content && 'nodes' in content ? isRichContentEmpty(content) : true,
    isBusy: false,
    editorKey: Date.now(),
});
const getIsValid = (state) => !state.isBusy && !state.isEmpty;
export const useContentForm = ({ initialAuthorName, initialEmail, initialContent, onTyping, }) => {
    const [state, setState] = React.useState(getInitialFormState(initialContent, initialAuthorName, initialEmail));
    return {
        ...state,
        onChange: (props) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    // In some cases editor calls 'onChange' even after it already should be remounted
                    return prevState;
                }
                if (onTyping && !props.contentTraits.isEmpty) {
                    props.contentTraits.isContentChanged && onTyping();
                }
                return {
                    ...prevState,
                    content: props.content,
                    isEmpty: props.contentTraits.isEmpty,
                    editorKey: prevState.editorKey,
                };
            });
        },
        onAuthorNameChange: (authorName) => setState((prev) => ({ ...prev, authorName })),
        onEmailChange: (email) => setState((prev) => ({ ...prev, email })),
        onBusyChange: (isBusy) => {
            setState((prevState) => {
                if (state.editorKey !== prevState.editorKey) {
                    return prevState;
                }
                return {
                    ...prevState,
                    isBusy,
                    editorKey: prevState.editorKey,
                };
            });
        },
        reset: () => setState(getInitialFormState()),
        getIsValid,
        getIsEmpty: () => state.isEmpty,
        validate: ({ asGuest, rating, isReply, guestUsernameRequired, guestEmailRequired, isEmptyOverride, }) => {
            const validateRating = (value) => isReply ? true : rating?.isRequired ? !!value : true;
            const { authorName, email } = state;
            const isEmpty = isEmptyOverride ?? state.isEmpty;
            const contentFormIsValid = !isEmpty && !state.isBusy;
            const emailIsValid = !email || emailRegex.test(email);
            const authorNameIsValid = !!authorName;
            const ratingIsValid = validateRating(rating?.value);
            const guestValidation = !asGuest ||
                ((!guestUsernameRequired || authorNameIsValid) && (!guestEmailRequired || emailIsValid));
            const isFormValid = contentFormIsValid && ratingIsValid && guestValidation;
            return {
                contentFormIsValid,
                emailIsValid,
                authorNameIsValid,
                ratingIsValid,
                isFormValid,
            };
        },
    };
};
//# sourceMappingURL=use-content-form.js.map